var map = {
	"./ACEWINFISHActions.js": "7434",
	"./ACEWINSLOTActions.js": "9a98",
	"./AELIVECOMMActions.js": "9c74",
	"./AELOTTOActions.js": "03ff",
	"./AVIATORActions.js": "e85f",
	"./AWSEGAMEActions.js": "08de",
	"./AWSSLOTActions.js": "df52",
	"./AWSTABLEActions.js": "d04e",
	"./BGActions.js": "c29b",
	"./BTGActions.js": "a8ec",
	"./CGEGAMEActions.js": "475b",
	"./CGSLOTActions.js": "8952",
	"./COMBOActions.js": "0398",
	"./COOLGAMEActions.js": "44b9",
	"./CQ9EGAMEActions.js": "9a37",
	"./CQ9FISHActions.js": "efb2",
	"./CQ9SLOTActions.js": "442c",
	"./CQ9TABLEActions.js": "e732",
	"./CRASH88Actions.js": "9b81",
	"./CREEDROOMZActions.js": "bcc3",
	"./DRAGOONSOFTActions.js": "145f",
	"./E1SPORTActions.js": "2d46",
	"./EVOLUTIONActions.js": "3f57",
	"./FASTSPINFISHActions.js": "9bee",
	"./FASTSPINSLOTActions.js": "f100",
	"./FCEGAMEActions.js": "a526",
	"./FCFISHActions.js": "87e8",
	"./FCSLOTActions.js": "d93b",
	"./FIVEGActions.js": "595a",
	"./GOGOLIActions.js": "efca",
	"./GTFFISHActions.js": "d278",
	"./GTFSLOTActions.js": "d28a",
	"./HABANEROEGAMEActions.js": "b32d",
	"./HABANEROSLOTActions.js": "06ca",
	"./HACKSAWEGAMEActions.js": "f823",
	"./HACKSAWSLOTActions.js": "e533",
	"./HORSEBOOKActions.js": "16ea",
	"./HOTROADActions.js": "1a14",
	"./IDNSLOTActions.js": "efb8",
	"./ILOVEUActions.js": "b079",
	"./INSPORTSActions.js": "2f92",
	"./JDBEGAMEActions.js": "a394",
	"./JDBFISHActions.js": "c889",
	"./JDBSLOTActions.js": "78ad",
	"./JDBTABLEActions.js": "0e1e",
	"./JILIFISHActions.js": "1ff9",
	"./JILISLOTActions.js": "fb83",
	"./JILITABLEActions.js": "0971",
	"./JJEGAMEActions.js": "d622",
	"./JJSLOTActions.js": "2f61",
	"./JOKERActions.js": "2245",
	"./KINGMAKERMINIActions.js": "8281",
	"./KINGMAKERSLOTActions.js": "55de",
	"./KINGMAKERTABLEActions.js": "e0c6",
	"./LADYLUCKActions.js": "8ec9",
	"./LETSGOActions.js": "601d",
	"./LUCKY365EGAMEActions.js": "50cd",
	"./LUCKY365SLOTActions.js": "2bee",
	"./LUCKYPOKERActions.js": "0b2b",
	"./LUDOActions.js": "2cf47",
	"./MAC88Actions.js": "1592",
	"./MGEGAMEActions.js": "f111",
	"./MGLIVEActions.js": "860f",
	"./MGSLOTActions.js": "9c50",
	"./MICROSLOTEGAMEActions.js": "e361",
	"./MICROSLOTSLOTActions.js": "edc6",
	"./MIMIEGAMEActions.js": "f524",
	"./MIMISLOTActions.js": "37df",
	"./MTActions.js": "5f71",
	"./NETENTSLOTActions.js": "968d",
	"./NETENTTABLEActions.js": "6e0e",
	"./NEXTSPINActions.js": "1c18",
	"./NLCActions.js": "7b16",
	"./OCTOPLAYActions.js": "16c2",
	"./ODINActions.js": "7130",
	"./PENGUINKINGActions.js": "b335",
	"./PGSLOTActions.js": "f141",
	"./PGSLOTMIXEDActions.js": "aa5c",
	"./PGSLOTOLDActions.js": "621f",
	"./PGTABLEActions.js": "44e9",
	"./PINNACLEActions.js": "bd28",
	"./PINOYPERYAHANActions.js": "63b7",
	"./PLAY8FISHActions.js": "f15b",
	"./PLAY8SLOTActions.js": "add4",
	"./PLAYNGOBINGOActions.js": "46af",
	"./PLAYNGOEGAMEActions.js": "1aca",
	"./PLAYNGOSLOTActions.js": "8bf8",
	"./PLAYNGOTABLEActions.js": "d7de",
	"./PLAYSTARActions.js": "be4e",
	"./PLAYTECHEGAMEActions.js": "9eec",
	"./PLAYTECHLIVEActions.js": "fcf1",
	"./PLAYTECHSLOTActions.js": "826b",
	"./PLAYTECHTABLEActions.js": "5583",
	"./PPEGAMEActions.js": "3c42",
	"./PPLIVEActions.js": "f6c1",
	"./PPSLOTActions.js": "c092",
	"./PPTABLEActions.js": "1da7",
	"./PTLIVEActions.js": "eb1d",
	"./PTSLOTActions.js": "bc3e",
	"./PlatformActions.js": "0b9c",
	"./RELAXEGAMEActions.js": "e232",
	"./RELAXSLOTActions.js": "17f4",
	"./RELAXTABLEActions.js": "83cf",
	"./RICH88EGAMEActions.js": "0aa0",
	"./RICH88SLOTActions.js": "51af",
	"./RICH88TABLEActions.js": "1fbc",
	"./ROYALGAMINGActions.js": "8ae3",
	"./RTSLOTActions.js": "4d38",
	"./RTTABLEActions.js": "1299",
	"./SABAActions.js": "c2a3",
	"./SABAOLDActions.js": "4704",
	"./SEXYBCRTActions.js": "7b9a",
	"./SEXYBCRT_SUMMARYActions.js": "2090",
	"./SKYCASINOActions.js": "b081",
	"./SMARTSOFTActions.js": "2be9",
	"./SPADEEGAMEActions.js": "1301",
	"./SPADEFISHActions.js": "9b39",
	"./SPADESLOTActions.js": "e4bd",
	"./SPRIBEActions.js": "3000",
	"./SV388Actions.js": "065f",
	"./TADAEGAMEActions.js": "4dc4",
	"./TADAFISHActions.js": "31ed",
	"./TADASLOTActions.js": "1c28",
	"./TADATABLEActions.js": "9e9e",
	"./THREEOAKSActions.js": "b3d3",
	"./VENUSActions.js": "eec7",
	"./VIACASINOActions.js": "82a1",
	"./VRLOTTOActions.js": "8486",
	"./WINFINITYActions.js": "652a",
	"./YESBINGOBINGOActions.js": "2902",
	"./YESBINGOEGAMEActions.js": "12b5",
	"./YESBINGOFISHActions.js": "a932",
	"./YESBINGOSLOTActions.js": "17b4",
	"./YGGDRASILSLOTActions.js": "d4e0",
	"./YGGDRASILTABLEActions.js": "3aa6",
	"./YLEGAMEActions.js": "1f2d",
	"./YLFISHActions.js": "96da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0aee";